import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useNationalities } from "../../../../../../utils/hooks/useNationalities/useNationalities";
import {
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  useTheme,
  FormControl,
} from "@material-ui/core";
import Text from "../../../../../shared/components/Text";

export const CountrySelection = ({ ...rest }) => {
  const { control, errors } = useFormContext();
  const { nationalities } = useNationalities();
  const { palette } = useTheme();
  const countrySelectionError = errors?.address?.country;

  return (
    <Controller
      name={rest.name}
      control={control}
      rules={rest.rules}
      {...rest}
      render={(props) => {
        return (
          <FormControl fullWidth {...rest}>
            <InputLabel error={!!countrySelectionError} id="country">
              <Text tId="COUNTRY" />
            </InputLabel>
            <Select
              MenuProps={{
                MenuListProps: {
                  "aria-label": "Select country",
                },
              }}
              placeholder={rest.placeholder}
              fullWidth
              onChange={(e) => {
                return props.onChange(e.target.value);
              }}
              defaultValue={props.value}
              value={props.value}
              error={!!countrySelectionError}
              {...props}
            >
              {nationalities.map((type, index) => (
                <MenuItem key={index} value={type.value}>
                  {type.label}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText style={{ color: palette.error.main }}>
              {countrySelectionError?.message}
            </FormHelperText>
          </FormControl>
        );
      }}
    />
  );
};
